import "@/index.css";
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import { SemmyWidget } from './components/SemmyWidget';
import { Login } from './pages/Login';
// Registration disabled - import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { Projects } from './pages/Projects';
import { ProjectDetail } from './pages/ProjectDetail';
import { TimeTracking } from './pages/TimeTracking';
import { Reports } from './pages/Reports';
import { Team } from './pages/Team';
import { ClientProfitability } from './pages/ClientProfitability';
import EmployeePerformance from './pages/EmployeePerformance';
import { SalaryAdmin } from './pages/SalaryAdmin';
import { LeaveManagement } from './pages/LeaveManagement';
import { Profile } from './pages/Profile';
import { AlertsConfig } from './pages/AlertsConfig';
import { CapacityPlanning } from './pages/CapacityPlanning';
import { ClientSurvey } from './pages/ClientSurvey';
import { ResetPassword } from './pages/ResetPassword';
import { Settings } from './pages/Settings';
import { Tasks } from './pages/Tasks';
import { AIAdmin } from './pages/AIAdmin';
import { OfficeExit } from './pages/OfficeExit';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-orange border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-orange border-t-transparent" />
      </div>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function AppContent() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        {/* Public survey page - no auth required */}
        <Route path="/survey/:token" element={<ClientSurvey />} />
        {/* Public password reset page */}
        <Route path="/reset-password" element={<ResetPassword />} />
{/* Registration disabled - admin adds users manually */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:id"
          element={
            <ProtectedRoute>
              <ProjectDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/time-tracking"
          element={
            <ProtectedRoute>
              <TimeTracking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/team"
          element={
            <ProtectedRoute>
              <Team />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-profitability"
          element={
            <ProtectedRoute>
              <ClientProfitability />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-performance"
          element={
            <ProtectedRoute>
              <EmployeePerformance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/salary-admin"
          element={
            <ProtectedRoute>
              <SalaryAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leave"
          element={
            <ProtectedRoute>
              <LeaveManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/capacity-planning"
          element={
            <ProtectedRoute>
              <CapacityPlanning />
            </ProtectedRoute>
          }
        />
        <Route
          path="/alerts-config"
          element={
            <ProtectedRoute>
              <AlertsConfig />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tasks"
          element={
            <ProtectedRoute>
              <Tasks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ai-admin"
          element={
            <ProtectedRoute>
              <AIAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoiri"
          element={
            <ProtectedRoute>
              <OfficeExit />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster position="top-right" />
      <SemmyWidget />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;